import * as actionTypes from './actionTypes';

export const stageUpdate = stage => {
    return {
        type: actionTypes.STAGE_UPDATE,
        stage,
    };
};

export const stageSuccess = stage => {
    return {
        type: actionTypes.STAGE_SUCCESS,
        stage,
    };
};

export const updateFlowFlags = data => {
    return {
        type: actionTypes.UPDATE_FLOW_FLAGS,
        data,
    };
};

export const updateSource = flag => {
    return {
        type: actionTypes.UPDATE_SOURCE,
        flag,
    };
};

export const updateSourceSuccess = flag => {
    return {
        type: actionTypes.UPDATE_SOURCE_SUCCESS,
        flag,
    };
};

export const loadClientId = clientId => {
    return {
        type: actionTypes.LOAD_CLIENT_ID,
        clientId,
    };
};

export const loadCustomerFlow = createCustomerFlow => ({
    type: actionTypes.UPDATE_CUSTOMER_FLOW,
    createCustomerFlow,
});
